module.exports = __webpack_public_path__ + "static/media/ICONS_PRODUCTOSYSERVICIOS.5453cd83.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ICONS/ICONS_PRODUCTOSYSERVICIOS.svg
// module id = 121
// module chunks = 0